import axios from 'axios'
import { get } from 'lodash'
import { getUiServicesEndpoint } from './utils'
import {
  ShipmentModificationVariables,
  ShipmentRowInterface,
} from '../common/types'

export const transformShipments = (shipments: Array<ShipmentRowInterface>) => {
  const cancelledShipments = shipments.map((shipment) => {
    const { bookingId, bookingVersion } = shipment
    return {
      booking_id: bookingId,
      booking_version: bookingVersion,
      change_reason: 'SHIPMENT_NOT_NEEDED',
    }
  })

  return {
    cancellation_requests: cancelledShipments,
  }
}

export const shipmentsCancellationsEndpoint = async ({
  shipments,
  uid,
}: ShipmentModificationVariables) => {
  const shipmentsToCancel = shipments.filter((shipment: any) => {
    return shipment?.toBeCancelled && !shipment?.loadId
  })
  const transformedShipments = transformShipments(shipmentsToCancel)
  if (uid <= 0) {
    return
  }
  if (transformedShipments?.cancellation_requests?.length <= 0) {
    return
  }
  const { key, url } = await getUiServicesEndpoint()
  const endpoint = `${url}/v1/shipment_cancellations?key=${key}`
  try {
    const response = await axios<ShipmentModificationVariables>({
      method: 'post',
      url: endpoint,
      data: transformedShipments,
    })
    const failures = get(response, 'data.failures', []).map((failure: any) => {
      return {
        booking_id: failure.booking_id,
        status: failure.status,
      }
    })
    const failedBookingIds = failures.map((failure: any) => failure.booking_id)
    const failedShipments = shipmentsToCancel
      .filter((shipment: any) => failedBookingIds.includes(shipment.bookingId))
      .map((shipment: any) => {
        const failure = failures.find(
          (f: any) => f.booking_id === shipment.bookingId,
        )
        return {
          ...shipment,
          failureStatus: failure?.status,
        }
      })
    return failedShipments
    // eslint-disable-next-line
  } catch (err: any) {
    return shipmentsToCancel.map((shipment: any) => ({
      ...shipment,
      failureStatus: 'ERROR',
    }))
  }
}
